import { PDFDocument, rgb } from 'pdf-lib';
import fontkit from '@pdf-lib/fontkit';
import tailwindConfig from '../../tailwind.config.js';
import { hexToRgb } from '../utils';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import 'dayjs/locale/fr';
import { CertifcateData } from '../types.js';

dayjs.extend(localizedFormat);

const getFont = async (pdfDoc: PDFDocument, fontName: string) => {
    const fonturl = `/fonts/${fontName}.ttf`;
    const fontBytes = await fetch(fonturl).then(res => res.arrayBuffer());
    const customFont = await pdfDoc.embedFont(fontBytes);

    return customFont;
};

export const generateCertificate = async (data: CertifcateData) => {
    console.log('generateCertificate', data);
    const date = dayjs(data.deliveryDate).locale(window.navigator.language).format('LL');

    const url = `/images/pdf/certificate-${data.theme}.pdf`;
    const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer());
    const pdfDoc: PDFDocument = await PDFDocument.load(existingPdfBytes);

    pdfDoc.registerFontkit(fontkit);
    const interSemibold = await getFont(pdfDoc, 'Inter-SemiBold');
    const interMedium = await getFont(pdfDoc, 'Inter-Medium');

    const pages = pdfDoc.getPages();
    const firstPage = pages[0];
    // const { width } = firstPage.getSize();

    const themeColorString =
        tailwindConfig.theme.extend.colors[`ar-${data.theme}` as keyof typeof tailwindConfig.theme.extend.colors];
    const themeColorObject = hexToRgb(themeColorString) as [number, number, number];

    firstPage.drawText(`${data.firstname}  ${data.last_name}`, {
        x: 78,
        y: 319,
        size: 23.8,
        font: interSemibold,
        color: rgb(...themeColorObject),
    });

    firstPage.drawText(data.formationName, {
        x: 78,
        y: 224,
        size: 23.8,
        font: interSemibold,
        color: rgb(...themeColorObject),
    });
    firstPage.drawText(date, {
        x: 78,
        y: 165,
        size: 13.9,
        font: interMedium,
        color: rgb(73 / 255, 85 / 255, 171 / 255),
    });

    firstPage.drawText(data.certificate_number, {
        x: 360,
        y: 18,
        size: 13.9,
        font: interSemibold,
        color: rgb(73 / 255, 85 / 255, 171 / 255),
    });

    const pdfBytes = await pdfDoc.save();

    // display in iframe
    const blob = new Blob([pdfBytes], { type: 'application/pdf' });
    // const iframe = document.querySelector('iframe');
    // if (!iframe) return;
    const blobUrl = URL.createObjectURL(blob);

    return blobUrl;
};

export const startDownloadCertificate = async (fileName: string, blobUrl: string) => {
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = fileName;
    // data.formationName + '_' + data.firstname.toLowerCase() + data.last_name.toLowerCase() + '_certificate.pdf';
    link.click();
};
